import { Col, Container, Row } from "react-bootstrap";
import JSONPretty from "../../jsonPrettyOverride/JSONPretty";
import classes from "./IntegrationOverview.module.scss"
import { tx } from "../../../lib/ddd/ddd";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import overviewPic from "../../../assets/overviewFac.png";
import stepsPic from "../../../assets/steps.png";
import DataObjectIcon from '@mui/icons-material/DataObject';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import DataArrayIcon from '@mui/icons-material/DataArray';
import NumbersIcon from '@mui/icons-material/Numbers';
import SettingsIcon from '@mui/icons-material/Settings';
import ArticleIcon from '@mui/icons-material/Article';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ApiIcon from '@mui/icons-material/Api';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { OrgIdContext } from "../../../store/orgId_context";
import { Link, NavLink } from "react-router-dom";
import { useContext } from "react";

const IntegrationOverview = () => {
    const { connectionKey, integrationDevice, connectionKeyMode } = useContext(OrgIdContext);
    const json1 = {"Object" : {}, Complexity:"Normal"}
    /* const json2 = {...json1 , "Steps":[]}
    const json3 = {...json2, "ReturnDoc":[]}
    const json4 = {...json3} */
    const json2 = {"Id" : "" , "Steps":[], Complexity:"Normal"}
    const json3 = {"Id" : "", "ReturnDoc":[], Complexity:"Normal"}
    const json4 = {"Object" : {},"Steps":[], "ReturnDoc":[],Complexity:"Normal"}

    const apiKeyTxt = "<api-key>"
    return (
        <Container>
            <Row style={{textAlign:"left", padding:"1rem"}}>
                    <div className={classes["container-card"]}>
                    {/* In this process, we will construct the invoice object step by step, as you would in your own in your own solutions. 
                    For this purpose, we will fill out our information using a basic form and select which operations we wish to execute 
                    upon our invoice (operations such as sending to tax authorities, email, etc). But first, sending... */}
                    In this process, we will construct the invoice object step by step to learn how to do this from your own solution. For this purpose, 
                    we will fill out the necessary invoice data using a basic form and select which operations we wish to execute upon our invoice 
                    (such as signing, sending it to tax authorities, Peppol network, archiving, etc.). But first, sending to the service…
                    </div>
                    

            </Row>
            <Row style={{textAlign:"left", padding:"1rem"}}>
            <h4 style={{textAlign:"left", padding:"0px"}}>How to send</h4> 
                <div className={classes["container-card"]}>
                    {/* To send requests to our services. You can use json.rpc library (more about this in 
                    <NavLink to="/technical-overview">Technical overview</NavLink>), or we can use the "curl" command. 
                    The request basically needs 3 pieces of information. */}
                    Samples in cURL are primarily intended to understand the structure of the requests. To send requests to our service, you can use whatever technology 
                    can send HTTPS POST/GET requests. 
                    If you use JavaScript, we strongly recommend using our jsonrpc-2.0.js library (more about this in the <NavLink to="/technical-overview">Technical overview</NavLink>). 
                    The request needs three pieces of information:
                    <ol style={{paddingLeft:"1rem", paddingTop:"1rem"}}>
                        <li>Identification (&lt;connectionKey&gt;)</li>
                        <li>API endpoint (&lt;api-name&gt;)</li> 
                        <li>Data (&lt;parameters&gt;)</li>
                    </ol>
                Here is an example such of a request:
                
                <div className={classes["code-snippet"]}>
                    curl -X POST https://{window.location.hostname}/api/service/<span className={classes.red}>&lt;api-name&gt;</span> -H "Authorization: IoT <span className={classes.red}>&lt;connectionKey&gt;</span>:EUeInvoices" -H "Content-Type: application/json" -d "&#123;<span className={classes.red}>&lt;parameters&gt;</span>&#125;"
                </div>
                {/* <div className={classes["code-snippet"]}>
                    {`curl -X POST https://dddinvoices.com/api/service/<api-key> -H "Authorization: IoT <connectionKey>:EUeInvoices" -H "Content-Type: application/json" -d "{<parameters>}"`}
                </div> */}
                {/* During integration, we will be using a connection key that is exclusively reserved for you to experiment with the implementation to your solutions. This <u>integration connection key</u> is: */}
                You will use the below <u>Integration Key</u> to learn and test the integration with our service. It is also used for all requests triggered by the 
                learning playground. All invoices sent with this key can be viewed in the "Integration -&gt; {tx("DDDI_Save")} -&gt; <NavLink to="/sent-integration-invoices">Sent invoices</NavLink>" menu (if the sending was 
                successful, at least to the extent that the object was accepted for processing).
                <div className={classes["code-snippet"]} >{integrationDevice}</div>

                <div className="alert alert-warning">{/* Note! Because sending invoices to external services, like tax authorities, requires that we have set up all sorts of other information (accounts, certificates, etc.) 
                and because many of these services require two variations of settings (testing and production), for this reason, while your connection key is in Test mode, we will be  using the settings of DDDInvoices company. When you are ready, 
                you can move your connection key to Production mode, which will start using your settings, and invoices should start flowing directly to you. But while in Test mode, you will only be able to see your sent invoices using our 
                interface in <NavLink to="/edit-invoices">Recieved invoices</NavLink>. */}
                Note! This is not a key intended to be used for your company's actual invoices. You can find the key that belongs to your company 
                in your company profile. Start using your company's key (called Connection Key) only when you've already learned the basic integration process.
                </div>
                And finally, for this we will be using the "{tx("EUeInvoices.DDDI_Save")}" API endpoint, making our request the following:
                <div className={classes["code-snippet"]}>
                    curl -X POST https://{window.location.hostname}/api/service/<span className={classes.green}>{tx("EUeInvoices.DDDI_Save")}</span> -H "Authorization: IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d "&#123;<span className={classes.red}>&lt;parameters&gt;</span>&#125;"
                </div>
                
                {/* The only thing missing now is the parameters of our invoice. For this, will go through the following steps below. The purpose of this exercise is for you to learn about the 3 first level parameters (Object, Steps, ReturnDoc). 
                If you wish, you can quickly skip to the end and see the complete json object being sent to DDDI_Save api. */}
                </div>
                
            </Row>
            <Row style={{textAlign:"left", padding:"1rem"}}>
                <h4 style={{textAlign:"left", padding:"0px"}}>What to send</h4> 
                <div className={classes["container-card"]}>
                The only thing missing now is the parameters of our invoice. For this, we will go through the following steps below. This exercise aims 
                to learn about the three first-level parameters (Object, Steps, ReturnDoc). If you wish, you can quickly skip to the end and see 
                the complete JSON object being sent to the {tx("DDDI_Save")} API. Then, repair the data and repeat the cycle - until the invoice data
                are successfully sent.
                </div>
            </Row>
            <Row className={`flex-nowrap ${classes["jsons-row"]}`}>
                <Col>
                    <Row className="h-100" >
                        <Col className="h-100" >
{/*                         <div className={classes["desc-wrapper"]}>
                            <h5 className={classes["wiz-title"]}>1. Invoice</h5>
                            <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}} >
                                <li><ArrowForwardIcon className={classes["fa"]}/>In the first step we will fill up the invoice object with our testing information. This is what the "Object" keyword is intended.</li>
                                <li><ArrowForwardIcon className={classes["fa"]}/>For now, we're going to ignore the "Complexity" parameter. At this moment, it is enough to know, that it is a required parameter.</li>
                            </ul>
                            <img src={overviewPic} width="100%" alt="frac"/>
                        </div> */}
                            <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
                                <h5 className={classes["wiz-title"]}>1. Invoice</h5>
                                <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}} >
                                    <li><DataObjectIcon className={classes["fa"]}/>In the first step, we will fill up the invoice object with our testing information. This is what the "Object" keyword is intended</li>
                                    <li><QuestionMarkIcon className={classes["fa"]}/>For now, we're going to ignore the "Complexity" parameter. At this moment, it is enough to know, that it controls the amount of invoice data parameters ("Maximal" has over 80 parameters) 
                                    and that it is a required parameter</li>
                                </ul>
                                <div className="mt-auto w-100">
                                {/* <img src={overviewPic} width="100%" alt="frac"/> */}
                                </div>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100" >
                        <Col className="h-100" >
                            <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
                                <h5 className={classes["wiz-title"]}>2. Steps</h5>
                                <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}}>
                                    <li><SettingsIcon className={classes["fa"]}/>Here, we will select all the steps that will be performed on our invoice 
                                                                                    (for example, the step code for sending to the Tax authorities is "70")</li>
                                    <li><DataArrayIcon className={classes["fa"]}/>This will be a simple array of <u>integers</u> that we will put under the "Steps" keyword</li>
                                    <li><NumbersIcon className={classes["fa"]}/>Each step has its own code. We will learn which ones are available and include them on our test invoice</li>
                                </ul>
                                <div className="mt-auto w-100">
                                {/* <img src={stepsPic} width="100%" alt="stepsPic"/> */}
                                </div>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100" >
                        <Col className="h-100" >
                            <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
                                <h5 className={classes["wiz-title"]}>3. Returned documents</h5>
                                <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}}>
                                    <li><SettingsIcon className={classes["fa"]}/>We will decide which documents we require back</li>
                                    <li><ArticleIcon className={classes["fa"]}/>The API response upon successful execution of our invoice and steps will return the links to these documents</li>
                                    <li><DataArrayIcon className={classes["fa"]}/>Just like with steps, each document has its own code that will be passed in a simple array. (for example, the code for PDF is simply "PDF")</li>
                                </ul>
                                <div className="mt-auto w-100"></div>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100" >
                        <Col className="h-100" >
                            <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
                                <h5 className={classes["wiz-title"]}><NumbersIcon/> Full</h5>
                                <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}} >
                                    <li><CloudUploadIcon className={classes["fa"]}/>The final step is to execute our invoice</li>
                                    <li><ApiIcon className={classes["fa"]}/>For that, we are going to send your invoice to {tx("DDDI_Save")} API</li>
                                    <li><DoneAllIcon className={classes["fa"]}/>If all goes well, your invoice should be processed according to the information and steps your selected</li>
                                </ul>
                                <div className="mt-auto w-100">
                                {/* <img src={overviewPic} width="100%" alt="frac"/> */}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className={`flex-nowrap ${classes["jsons-row"]}`}>
                <Col >
                    <Row className="h-100 flex-nowrap" >
                        <Col className="h-100" >
                            <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json1} fieldName={"Object"}/>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"><ArrowForwardIcon/></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100 flex-nowrap" >
                        <Col className="h-100" >
                            <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json2} fieldName={"Steps"}/>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"><ArrowForwardIcon/></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100 flex-nowrap" >
                        <Col className="h-100" >
                            <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json3} fieldName={"ReturnDoc"}/>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"><ArrowForwardIcon/></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100 flex-nowrap" >
                        <Col className="h-100" >
                            <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json4} fieldKeys={["Object", "Steps", "ReturnDoc"]}/>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {/* <Row className="flex-nowrap" style={{height:"80vh", backgroundColor:"red"}}>
                <Col>
                    <Row style={{height:"70%", backgroundColor:"blue"}}></Row>
                    <Row style={{height:"30%", backgroundColor:"yellow"}}>
                    <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json3} fieldName={"ReturnDoc"}/>
                            </div>
                    </Row>
                </Col>
                <Col>
                    <Row style={{height:"70%", backgroundColor:"blue"}}></Row>
                    <Row style={{height:"30%", backgroundColor:"yellow"}}>
                    <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json3} fieldName={"ReturnDoc"}/>
                            </div>
                    </Row>
                </Col>
                <Col>
                    <Row style={{height:"70%", backgroundColor:"blue"}}></Row>
                    <Row style={{height:"30%", backgroundColor:"yellow"}}>
                    <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json3} fieldName={"ReturnDoc"}/>
                            </div>
                    </Row>
                </Col>
                <Col>
                <Row style={{height:"70%", backgroundColor:"blue"}}></Row>
                    <Row style={{height:"30%", backgroundColor:"yellow"}}>
                        <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json3} fieldName={"ReturnDoc"}/>
                        </div>
                    </Row>
                </Col>
            </Row> */}
        </Container>
    )
}

export default IntegrationOverview;